import { faBars, faCalendar, faCodeBranch, faHashtag, faPen, faQuestion } from "@fortawesome/free-solid-svg-icons";

function ParameterIcon(idType) {

    /*
      ID	Name
      1	Логический
      2	Число
      3	Строка
      4	Справочник
      5	Дата
      */

    if (idType === 1) {
        return faCodeBranch
    }
    else if (idType === 2) {
        return faHashtag
    }
    else if (idType === 3) {
        return faPen
    }
    else if (idType === 4) {
        return faBars
    }
    else if (idType === 5) {
        return faCalendar
    }
    else {
        return faQuestion
    }
}

export default ParameterIcon;